import { useEffect, useRef } from 'react';
import { createContext, useState } from 'react';
import { resourceApi,sessionApi } from './interceptors';
import { resource_server } from "@utils/settings"
import {searchService}from '@utils/utils';
import {io} from 'socket.io-client'

const GlobalStateContext = createContext();


const GlobalStateProvider = ({ children }) => {
    const [profile, setProfile] = useState({})
    const [cards, setCards] = useState([])
    const [hideMenu, setHideMenu] = useState(false)
    const [chatEnabled, setChatEnabled] = useState(false)
    const [redirectUrl, setRedirectUrl] = useState(localStorage.getItem('redirectUrl'));
    const [piani, setPiani] = useState([])
    const [loading, setLoading] = useState({
        isLoading: true,
        message: '',
        duration: 10
    })
    const [appSettings, setAppSettings] = useState()
    const [settings, setSettings] = useState()

    // Socket creata UNA sola volta (non a ogni render): altrimenti ogni re-render
    // genera una nuova istanza + nuova connessione e si perdono gli eventi in ascolto.
    const socketRef = useRef(null)
    if (socketRef.current === null) {
      socketRef.current = io(import.meta.env.VITE_SOCKET_URI,{
        reconnection: true,
        requestTimeout:550,
        autoConnect:false,
        extraHeaders: {
          userId: profile['_id']
        }
      })
    }
    const socket = socketRef.current

    // --- DEBUG socket ---
    useEffect(() => {
        const onConnect = () => console.log('[SOCKET] connect', socket.id)
        const onDisconnect = (reason) => console.log('[SOCKET] disconnect', reason)
        const onConnectError = (err) => console.log('[SOCKET] connect_error', err?.message || err)
        const onAny = (ev, ...args) => console.log('[SOCKET] IN', ev, args)
        socket.on('connect', onConnect)
        socket.on('disconnect', onDisconnect)
        socket.on('connect_error', onConnectError)
        socket.onAny(onAny)
        console.log('[SOCKET] init', { uri: import.meta.env.VITE_SOCKET_URI, id: socket.id, connected: socket.connected })
        return () => {
            socket.off('connect', onConnect)
            socket.off('disconnect', onDisconnect)
            socket.off('connect_error', onConnectError)
            socket.offAny(onAny)
        }
    }, [socket])

    useEffect(()=>{
      if(profile && profile._id && !socket.connected){
        socket.io.opts.extraHeaders = {userId: profile._id}
        socket.connect()
      }
    },[profile])

    const getCards=async()=>{
        if(Object.keys(profile).length>0){
            if(profile.role==='esercente'){
                setCards(await resourceApi.get('/esercente/carte_di_credito'))
            }
            else {
                setCards(await resourceApi.get('/cliente/carte_di_credito'))
            }

        }
    }
    useEffect(()=>{
        getCards()
    },[profile])


  const refreshProfile = async()=>{
    setProfile(await resourceApi.get('/get_myself'))
  } 
    useEffect(()=>{

        async function init(){
              try{
                    await sessionApi.get('/session')
                } catch(ex){
                    
                     window.location.href = `${resource_server}/login?referrer=${window.location}`
                     return
                }

            try {
                let plans = await resourceApi.post('/search/abbonamenti',{"query":{},"sort":{"_id":1},"search":"","page":0,"limit":10,"filters":{},"initial_filters":{}}
                )
                setPiani(plans.data)
                
                setProfile(await resourceApi.get('/get_myself'))
                setAppSettings(await resourceApi.get('/app_settings'))
                setSettings(await resourceApi.get('/get_settings'))
                setLoading((prev)=>{
                    
                        return {
                            ...prev, 
                            isLoading: false
                        }
                    })

            } catch(ex){
                debugger
            }
       
         
        }

        init()
        
        
       
    },[])
      const GlobalState = {
        profile, setProfile, loading, setLoading,settings,appSettings,cards, setCards, getCards, hideMenu, setHideMenu,chatEnabled, setChatEnabled,redirectUrl,setRedirectUrl,refreshProfile,piani,socket
    };
    return (
        <GlobalStateContext.Provider value={GlobalState}>
        {children}
        </GlobalStateContext.Provider>
    );
};

export { GlobalStateContext, GlobalStateProvider };
